import { FC } from 'react';
// components
import EditSupplierComponent from 'components/main/Supplier/Edit';

const EditSupplier: FC = () => <EditSupplierComponent />;

export default EditSupplier;
